Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_syntax_highlighter_1 = require("react-syntax-highlighter");
var hljs_1 = require("react-syntax-highlighter/dist/cjs/styles/hljs");
var CodeBlock = function (props) {
    var style = props.theme === 'dark' ? hljs_1.atomOneDark : hljs_1.docco;
    return (React.createElement(react_syntax_highlighter_1.default, { language: props.langauge, style: style }, props.children));
};
exports.default = CodeBlock;
//# sourceMappingURL=index.js.map